// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Q0-z","colorTextValue":"R0-z","swatches":"S0-z","collapseLink":"T0-z","isCollapsed":"U0-z","dropdown":"V0-z","disabled":"W0-z"};